import React from "react";
import { FiVideo } from "react-icons/fi";
import Dropzone from "../ui/Dropzone";
import RadioGroup from "../ui/RadioGroup";
import TextArea from "../ui/TextArea";
import TextField from "../ui/TextField";
import { COSMETIC_CONDITION_OPTIONS, YES_NO_OPTIONS } from "../options";

function Question({ label, children }) {
  return (
    <div>
      <p className="rma-nc-question-label">{label}</p>
      {children}
    </div>
  );
}

/*
The triage questions asked before a claim is accepted. Answering them up
front is what keeps no-fault-found returns down, so they are required
reading rather than an optional extra. They are asked of customers and
retailers alike.
*/
export default function PreQualificationSection({ form, onRecordingAdded }) {
  const { values, setField } = form;

  return (
    <div className="rma-nc-prequalification">
      <Question label="Please provide a clear description of the fault or claim.">
        <TextArea
          size="md"
          minHeight={78}
          placeholder="Describe the fault or reason for the claim"
          value={values.faultDescription}
          onChange={(event) => setField("faultDescription", event.target.value)}
        />
      </Question>

      <Question label="Has the fault been replicated in store?">
        <RadioGroup
          name="replicated-in-store"
          options={YES_NO_OPTIONS}
          value={values.replicatedInStore}
          onChange={(answer) => setField("replicatedInStore", answer)}
          className="rma-nc-radio-group--narrow rma-nc-mb-10"
        />
        <TextArea
          size="md"
          minHeight={66}
          placeholder="If yes, please describe the steps taken to replicate the fault."
          value={values.replicationSteps}
          onChange={(event) => setField("replicationSteps", event.target.value)}
        />
      </Question>

      <Question label="Preferable - If the fault has been replicated, please upload a video showing the fault.">
        <Dropzone
          compact
          icon={FiVideo}
          title="Upload a recording"
          hint="Video showing the fault being replicated"
          accept="video/*"
          onFiles={onRecordingAdded}
        />
      </Question>

      <Question label="Cosmetic Condition - Is there any visible physical damage to the product?">
        <RadioGroup
          name="cosmetic-condition"
          options={COSMETIC_CONDITION_OPTIONS}
          value={values.cosmeticCondition}
          onChange={(answer) => setField("cosmeticCondition", answer)}
          hideIndicator
          className="rma-nc-radio-group--stacked"
        />
        {values.cosmeticCondition === "other" && (
          <TextField
            label="Please specify"
            size="md"
            placeholder="Describe the cosmetic condition"
            value={values.cosmeticConditionOther}
            onChange={(event) => setField("cosmeticConditionOther", event.target.value)}
            wrapperClassName="rma-nc-mt-10"
          />
        )}
      </Question>

      <Question label="Has all water, debris, dust or other residue been removed from the product?">
        <RadioGroup
          name="water-and-debris"
          options={YES_NO_OPTIONS}
          value={values.waterAndDebrisRemoved}
          onChange={(answer) => setField("waterAndDebrisRemoved", answer)}
          className="rma-nc-radio-group--narrow"
        />
      </Question>

      <Question label="Are any accessories or consumables missing?">
        <TextArea
          size="md"
          minHeight={66}
          placeholder="List any missing accessories or consumables (or 'None')"
          value={values.missingAccessories}
          onChange={(event) => setField("missingAccessories", event.target.value)}
        />
      </Question>
    </div>
  );
}
